module.exports = __webpack_public_path__ + "img/Phone3.a3eec199.svg";